// Yup
import { string, object, array, boolean } from "yup";
import { messagesTypesShape } from "./Shapes/MessagesTypesShape";

export const clientValidationSchema = object({
  name: string("Enter the clinic's name").required("Clinic name is required"),
  domain: string("Enter the clinic's domain").required(
    "Clinic domain is required"
  ),

  settings: object({
    appointmentLocations: boolean(),
    appointmentReasons: boolean(),
  }).test(
    "at-least-one-true",
    "Please enable at least one of the following options: Appointment Locations or Appointment Reasons.",
    (value) =>
      !!value && (value.appointmentLocations || value.appointmentReasons)
  ),

  appointmentLocations: array().when("settings.appointmentLocations", {
    is: true,
    then: (schema) =>
      schema
        .of(
          object({
            location: object({
              en: string().trim().required("English location cannot be empty."),
              fr: string().trim().required("French location cannot be empty."),
            }),
            information: object(),
          })
        )
        .min(1, "One or more appointment locations must be entered"),
    otherwise: (schema) =>
      schema.of(
        object({
          location: object({
            en: string().trim(),
            fr: string().trim(),
          }),
          information: object(),
        })
      ),
  }),

  appointmentReasons: array().when("settings.appointmentReasons", {
    is: true,
    then: (schema) =>
      schema
        .of(
          object({
            en: string().trim().required("English reason cannot be empty."),
            fr: string().trim().required("French reason cannot be empty."),
          })
        )
        .min(1, "One or more appointment reasons must be entered"),
    otherwise: (schema) =>
      schema.of(
        object({
          en: string().trim(),
          fr: string().trim(),
        })
      ),
  }),
  defaultTextMessages: object().shape(messagesTypesShape),
});
